import type { ComponentProps } from 'react';
import RootStatsCard from '@shared/pages/Home/RootStatsCard';
import { useRegistrationSummary } from '../api';
import { REGISTRATION_EXPIRATION_WINDOW_DAYS } from '../constants';

type TProps = Omit<ComponentProps<typeof RootStatsCard>, 'stats'>;

const CountryRegistrationsCard = (props: TProps) => {
  const { data } = useRegistrationSummary();

  return (
    <RootStatsCard
      {...props}
      stats={[
        { label: 'Markets registered', value: data?.activeCountries },
        { label: `Renewals due in ${REGISTRATION_EXPIRATION_WINDOW_DAYS} days`, value: data?.renewalsDue },
      ]}
    />
  );
};

export default CountryRegistrationsCard;
